const MadagascarSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111805)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.0435 20V38.756C15.21 39.56 17.5535 40 19.9999 40C31.0456 40 39.9999 31.0456 39.9999 20C39.9999 8.95436 13.0435 20 13.0435 20Z"
        fill="#6DA544"
      />
      <path
        d="M19.9999 0C17.5535 0 15.21 0.440078 13.0435 1.24398V20H39.9999C39.9999 8.95437 31.0456 0 19.9999 0Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111805">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MadagascarSvg;
